/* Het zoekpaneel. Gebouwd naar twee voorbeelden: het brede resultatenpaneel
   van hairwebshop.com (categorieën links, producten met voorraad en prijs
   rechts, correctiemelding erboven) en de beginstand van keune.com (laatste
   zoekopdrachten, populaire termen en aanbevolen producten nog vóór er iets
   getypt is).

   De bron is Shopify's eigen suggest.json — dezelfde als de zoekpagina, dus
   wat hier staat vind je daar ook. Zonder JavaScript verandert er niets: het
   formulier is een gewone GET naar /search en dat blijft werken.

   Toetsenbord: pijltjes lopen door alles wat aanklikbaar is, Enter volgt de
   selectie, Escape sluit eerst het paneel en pas daarna de zoeklade. Het
   geheel is een combobox, zodat een schermlezer het leest als één veld met
   een lijst eronder. */

(function () {
  'use strict';

  var teksten = window.ncStrings || {};
  var WACHT = 200;       // milliseconden na de laatste toetsaanslag
  var MINIMUM = 2;       // korter zoeken levert alleen ruis op
  var RECENT_MAX = 6;
  var RECENT_SLEUTEL = 'nc-zoek-recent';

  var aanbevolenCache = null; // één keer per pagina ophalen, alle boxen delen

  function geld(bedrag) {
    var cent = Math.round(parseFloat(bedrag) * 100);
    if (isNaN(cent)) return '';
    return window.ncMoney ? window.ncMoney(cent) : bedrag;
  }

  /* localStorage kan dicht zitten (privémodus). Dan doen de laatste
     zoekopdrachten gewoon niet mee; de rest van het paneel merkt er niets
     van. */
  function leesRecent() {
    try {
      return JSON.parse(localStorage.getItem(RECENT_SLEUTEL) || '[]').filter(Boolean);
    } catch (e) { return []; }
  }

  function bewaarRecent(term) {
    term = (term || '').trim();
    if (term.length < MINIMUM) return;
    try {
      var laag = term.toLowerCase();
      var lijst = leesRecent().filter(function (t) { return t.toLowerCase() !== laag; });
      lijst.unshift(term);
      localStorage.setItem(RECENT_SLEUTEL, JSON.stringify(lijst.slice(0, RECENT_MAX)));
    } catch (e) { /* privémodus */ }
  }

  function wisRecent(term) {
    try {
      if (term === undefined) {
        localStorage.removeItem(RECENT_SLEUTEL);
      } else {
        var laag = term.toLowerCase();
        localStorage.setItem(RECENT_SLEUTEL, JSON.stringify(
          leesRecent().filter(function (t) { return t.toLowerCase() !== laag; })
        ));
      }
    } catch (e) { /* privémodus */ }
  }

  function maakBox(box, boxNummer) {
    var veld = box.querySelector('[data-zoekveld]');
    var paneel = box.querySelector('[data-zoekpaneel]');
    if (!veld || !paneel) return;

    var timer = null;
    var lopend = null;
    var keuze = -1;
    var items = [];
    var correctie = null;   // de term waarop werkelijk gezocht is, als die afwijkt

    function sluit() {
      paneel.hidden = true;
      paneel.innerHTML = '';
      veld.setAttribute('aria-expanded', 'false');
      veld.removeAttribute('aria-activedescendant');
      keuze = -1;
      items = [];
    }

    /* Na elke opbouw: alles met role=option wordt bestuurbaar met de
       pijltjes, in de volgorde waarin het op het scherm staat. */
    function verzamel() {
      items = [].slice.call(paneel.querySelectorAll('[role="option"]'));
      items.forEach(function (el, i) {
        if (!el.id) el.id = 'zoeksug-' + boxNummer + '-' + i;
        el.setAttribute('aria-selected', 'false');
      });
      keuze = -1;
      paneel.hidden = false;
      veld.setAttribute('aria-expanded', 'true');
      veld.removeAttribute('aria-activedescendant');
    }

    function markeer(n) {
      items.forEach(function (el, i) {
        var aan = i === n;
        el.classList.toggle('is-keuze', aan);
        el.setAttribute('aria-selected', aan ? 'true' : 'false');
      });
      if (n >= 0 && items[n]) {
        veld.setAttribute('aria-activedescendant', items[n].id);
        items[n].scrollIntoView({ block: 'nearest' });
      } else {
        veld.removeAttribute('aria-activedescendant');
      }
      keuze = n;
    }

    /* ------------------------------------------------------- bouwstenen -- */

    function kop(tekst) {
      var el = document.createElement('p');
      el.className = 'zoeksug__kop';
      el.textContent = tekst;
      return el;
    }

    function balk(linksTekst) {
      var rij = document.createElement('div');
      rij.className = 'zoeksug__balk';
      var links = document.createElement('div');
      links.className = 'zoeksug__balk-links';
      if (linksTekst) {
        var p = document.createElement('p');
        p.className = 'zoeksug__correctie';
        p.textContent = linksTekst;
        links.appendChild(p);
      }
      rij.appendChild(links);
      var dicht = document.createElement('button');
      dicht.type = 'button';
      dicht.className = 'zoeksug__sluit';
      dicht.setAttribute('data-zoek-sluit', '');
      dicht.textContent = teksten.close || 'Sluiten';
      rij.appendChild(dicht);
      return { rij: rij, links: links };
    }

    function tekstrij(soort, url, naam) {
      var a = document.createElement('a');
      a.className = 'zoeksug__rij zoeksug__rij--' + soort;
      a.href = url;
      a.setAttribute('role', 'option');
      var t = document.createElement('span');
      t.className = 'zoeksug__naam';
      t.textContent = naam;
      a.appendChild(t);
      return a;
    }

    /* Eén productregel: beeld, merk, naam, voorraad — en rechts de prijs met
       een eventuele doorgestreepte oude prijs. Zoals de regels bij
       hairwebshop, in de maten van dit thema. */
    function productrij(p) {
      var a = document.createElement('a');
      a.className = 'zoeksug__prod';
      a.href = p.url;
      a.setAttribute('role', 'option');

      var beeld = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
      if (beeld) {
        var img = document.createElement('img');
        img.className = 'zoeksug__prod-beeld';
        img.src = beeld;
        img.alt = '';
        img.loading = 'lazy';
        a.appendChild(img);
      }

      var tekst = document.createElement('span');
      tekst.className = 'zoeksug__prod-tekst';
      if (p.vendor) {
        var merk = document.createElement('span');
        merk.className = 'zoeksug__prod-merk';
        merk.textContent = p.vendor;
        tekst.appendChild(merk);
      }
      var naam = document.createElement('span');
      naam.className = 'zoeksug__prod-naam';
      naam.textContent = p.title;
      tekst.appendChild(naam);

      var opVoorraad = p.available !== false;
      var stock = document.createElement('span');
      stock.className = 'zoeksug__stock ' + (opVoorraad ? 'zoeksug__stock--in' : 'zoeksug__stock--uit');
      stock.textContent = opVoorraad ? (teksten.inStock || 'Op voorraad') : (teksten.soldOut || 'Uitverkocht');
      tekst.appendChild(stock);
      a.appendChild(tekst);

      var prijs = document.createElement('span');
      prijs.className = 'zoeksug__prod-prijs';
      var nu = document.createElement('span');
      nu.className = 'zoeksug__prod-nu';
      nu.textContent = geld(p.price);
      prijs.appendChild(nu);
      /* Min naast min. De getoonde prijs is de laagste variant; daar hoort de
         laagste oude prijs naast. Met compare_at_price_max stond hier "€6,25,
         was €58,95" — de travelsize naast de oude prijs van de literfles. */
      var was = parseFloat(p.compare_at_price_min || 0);
      if (was && was > parseFloat(p.price_min || p.price)) {
        var oud = document.createElement('s');
        oud.className = 'zoeksug__prod-was';
        oud.textContent = geld(was);
        prijs.appendChild(oud);
      }
      a.appendChild(prijs);
      return a;
    }

    /* --------------------------------------------- de lege beginstand ----- */

    /* Wat je ziet zodra je in het veld klikt, nog vóór het typen — zoals de
       zoekfunctie van keune.com: je laatste zoekopdrachten als weghaalbare
       chips, de populaire termen links en aanbevolen producten rechts. */
    function toonLeeg() {
      var bron = window.ncZoekLijst || {};
      paneel.innerHTML = '';
      correctie = null;

      var recent = leesRecent();
      if (recent.length) {
        var chipsrij = document.createElement('div');
        chipsrij.className = 'zoeksug__chips';
        var label = document.createElement('span');
        label.className = 'zoeksug__chips-label';
        label.textContent = (teksten.searchRecent || 'Laatste zoekopdrachten') + ':';
        chipsrij.appendChild(label);

        recent.forEach(function (term) {
          var chip = document.createElement('span');
          chip.className = 'zoeksug__chip';
          var knop = document.createElement('button');
          knop.type = 'button';
          knop.className = 'zoeksug__chip-term';
          knop.setAttribute('role', 'option');
          knop.setAttribute('data-zoek-term', term);
          knop.textContent = term;
          chip.appendChild(knop);
          var weg = document.createElement('button');
          weg.type = 'button';
          weg.className = 'zoeksug__chip-weg';
          weg.setAttribute('data-zoek-wis-term', term);
          weg.setAttribute('aria-label', (teksten.close || 'Sluiten') + ' — ' + term);
          weg.textContent = '×';
          chip.appendChild(weg);
          chipsrij.appendChild(chip);
        });

        var wis = document.createElement('button');
        wis.type = 'button';
        wis.className = 'zoeksug__chips-wis';
        wis.setAttribute('data-zoek-wis-alles', '');
        wis.textContent = teksten.searchClearRecent || 'Verwijder laatste zoekopdrachten';
        chipsrij.appendChild(wis);
        paneel.appendChild(chipsrij);
      }

      var romp = document.createElement('div');
      romp.className = 'zoeksug__romp zoeksug__romp--leeg';

      var zij = document.createElement('div');
      zij.className = 'zoeksug__zij';
      var termen = String(bron.populair || '').split(/[\n;]/)
        .map(function (t) { return t.trim(); })
        .filter(Boolean);
      if (termen.length) {
        zij.appendChild(kop(teksten.searchPopular || 'Populair'));
        termen.slice(0, 8).forEach(function (term) {
          var doel = window.ncZoekDoel ? window.ncZoekDoel(term) : null;
          var href = doel && doel.url ? doel.url : '/search?q=' + encodeURIComponent(term);
          zij.appendChild(tekstrij('populair', href, term));
        });
      }
      romp.appendChild(zij);

      var hoofd = document.createElement('div');
      hoofd.className = 'zoeksug__hoofd';
      hoofd.appendChild(kop(teksten.searchRecommended || 'Aanbevolen producten'));
      var vak = document.createElement('div');
      vak.className = 'zoeksug__kaarten';
      hoofd.appendChild(vak);
      romp.appendChild(hoofd);
      paneel.appendChild(romp);

      verzamel();
      vulAanbevolen(vak);
    }

    /* De aanbevolen producten komen uit een collectie (instelbaar bij Thema-
       instellingen → Zoeken) en worden één keer per pagina opgehaald. Komt het
       antwoord binnen terwijl de bezoeker al typt, dan is dit vak vervangen en
       gebeurt er niets — vandaar de isConnected-controle. */
    function vulAanbevolen(vak) {
      function teken(lijst) {
        if (!vak.isConnected) return;
        lijst.slice(0, 8).forEach(function (p) {
          var a = document.createElement('a');
          a.className = 'zoeksug__kaart';
          a.href = '/products/' + p.handle;
          a.setAttribute('role', 'option');
          if (p.beeld) {
            var img = document.createElement('img');
            img.className = 'zoeksug__kaart-beeld';
            img.src = p.beeld;
            img.alt = '';
            img.loading = 'lazy';
            a.appendChild(img);
          }
          var naam = document.createElement('span');
          naam.className = 'zoeksug__kaart-naam';
          naam.textContent = p.titel;
          a.appendChild(naam);
          var prijs = document.createElement('span');
          prijs.className = 'zoeksug__kaart-prijs';
          prijs.textContent = geld(p.prijs);
          a.appendChild(prijs);
          vak.appendChild(a);
        });
        verzamel();
      }

      if (aanbevolenCache) { teken(aanbevolenCache); return; }

      var bron = window.ncZoekLijst || {};
      var handle = bron.aanbevolen || 'haarproducten';
      fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=8')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.products) return;
          aanbevolenCache = d.products.map(function (p) {
            return {
              handle: p.handle,
              titel: p.title,
              prijs: p.variants && p.variants[0] ? p.variants[0].price : '',
              beeld: p.images && p.images[0] ? p.images[0].src : null
            };
          });
          teken(aanbevolenCache);
        })
        .catch(function () { /* dan geen aanbevolen blok; de rest staat er */ });
    }

    /* ------------------------------------------------- zoekresultaten ---- */

    function haal(vraag) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(vraag) +
        '&resources[type]=product,collection,article,page' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      return fetch(url, lopend ? { signal: lopend.signal } : undefined)
        .then(function (r) { return r.ok ? r.json() : null; });
    }

    function leeg(d) {
      var res = (d && d.resources && d.resources.results) || {};
      return !(res.products || []).length && !(res.collections || []).length;
    }

    function toon(data, vraag, getypt) {
      var res = (data && data.resources && data.resources.results) || {};
      var producten = res.products || [];
      var collecties = res.collections || [];
      var advies = (res.articles || []).concat(res.pages || []);

      if (!producten.length && !collecties.length) {
        sluit();
        return;
      }

      paneel.innerHTML = '';

      var koptekst = null;
      if (getypt && getypt !== vraag) {
        koptekst = (teksten.searchCorrected || 'Gezocht op') + ' “' + vraag + '” — ' +
          (teksten.searchTyped || 'jij typte') + ' “' + getypt + '”';
      }
      paneel.appendChild(balk(koptekst).rij);

      var romp = document.createElement('div');
      romp.className = 'zoeksug__romp';

      var zij = document.createElement('div');
      zij.className = 'zoeksug__zij';
      if (collecties.length) {
        zij.appendChild(kop(teksten.searchCollections || 'Lijnen en categorieën'));

        /* De oude en de vernieuwde Keune-lijnen heten precies hetzelfde, dus
           suggest.json geeft ze allebei terug: twee keer "Keune Care Silver
           Savior" onder elkaar. Hier wordt per naam één rij getoond, en de
           woordenlijst — die weet welke van de twee een lijnpagina heeft —
           bepaalt waar die rij heen wijst. */
        var plat = window.ncZoekPlat || function (t) { return String(t).toLowerCase(); };
        var gezien = {};
        collecties.forEach(function (c) {
          var naam = plat(c.title);
          if (gezien[naam]) return;
          gezien[naam] = true;
          var doel = window.ncZoekDoel ? window.ncZoekDoel(c.title) : null;
          var url = doel && doel.soort === 'collectie' && doel.url ? doel.url : c.url;
          if (Object.keys(gezien).length > 4) return;
          zij.appendChild(tekstrij('collectie', url, c.title));
        });
      }
      if (advies.length) {
        zij.appendChild(kop(teksten.searchAdvice || 'Advies'));
        advies.slice(0, 3).forEach(function (x) {
          zij.appendChild(tekstrij('advies', x.url, x.title));
        });
      }
      romp.appendChild(zij);

      var hoofd = document.createElement('div');
      hoofd.className = 'zoeksug__hoofd';
      if (producten.length) {
        hoofd.appendChild(kop(teksten.searchProducts || 'Producten'));
        producten.slice(0, 6).forEach(function (p) {
          hoofd.appendChild(productrij(p));
        });
      }
      var alles = document.createElement('a');
      alles.className = 'zoeksug__alles';
      alles.href = '/search?q=' + encodeURIComponent(vraag);
      alles.setAttribute('role', 'option');
      alles.textContent = (teksten.searchAll || 'Alle resultaten voor') + ' “' + vraag + '”';
      hoofd.appendChild(alles);
      romp.appendChild(hoofd);
      paneel.appendChild(romp);

      verzamel();
    }

    /* Levert de getypte tekst niets op, dan wordt hij langs de namen gelegd
       die in deze winkel bestaan en met de verbeterde term opnieuw gezocht.
       De bezoeker ziet wát er gezocht is — anders lijkt het alsof de winkel
       zijn typefout gewoon kende, en dat is verwarrend zodra de correctie er
       een keer naast zit. */
    function zoek(vraag) {
      if (lopend) lopend.abort();
      lopend = typeof AbortController === 'function' ? new AbortController() : null;

      haal(vraag)
        .then(function (d) {
          if (!d) return;
          if (!leeg(d)) {
            correctie = null;
            toon(d, vraag);
            return;
          }
          var beter = window.ncZoekTerm ? window.ncZoekTerm(vraag) : null;
          if (!beter) {
            correctie = null;
            toon(d, vraag);
            return;
          }
          return haal(beter).then(function (d2) {
            if (!d2 || leeg(d2)) {
              correctie = null;
              toon(d, vraag);
              return;
            }
            correctie = beter;
            toon(d2, beter, vraag);
          });
        })
        .catch(function () { /* afgebroken of offline: laat staan wat er staat */ });
    }

    /* ------------------------------------------------------- gebeurtenis -- */

    veld.addEventListener('focus', function () {
      var vraag = veld.value.trim();
      if (vraag.length < MINIMUM) {
        toonLeeg();
      } else if (paneel.hidden) {
        zoek(vraag);
      }
    });

    veld.addEventListener('input', function () {
      var vraag = veld.value.trim();
      clearTimeout(timer);
      if (vraag.length < MINIMUM) {
        // Leeggemaakt? Dan terug naar de beginstand, niet naar niets.
        toonLeeg();
        return;
      }
      timer = setTimeout(function () { zoek(vraag); }, WACHT);
    });

    veld.addEventListener('keydown', function (e) {
      if (paneel.hidden) {
        if (e.key === 'ArrowDown') {
          var vraag = veld.value.trim();
          if (vraag.length >= MINIMUM) { zoek(vraag); } else { toonLeeg(); }
        }
        return;
      }
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        markeer((keuze + 1) % items.length);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        markeer(keuze <= 0 ? items.length - 1 : keuze - 1);
      } else if (e.key === 'Enter') {
        if (keuze >= 0 && items[keuze]) {
          e.preventDefault();
          var el = items[keuze];
          if (el.dataset.zoekTerm) {
            veld.value = el.dataset.zoekTerm;
            zoek(el.dataset.zoekTerm);
          } else if (el.href) {
            bewaarRecent(veld.value);
            window.location.href = el.href;
          }
        }
      } else if (e.key === 'Escape') {
        // Alleen het paneel sluiten. Zonder stopPropagation zou de
        // overlaybeheerder dezelfde Escape zien en meteen ook de hele
        // zoeklade dichtdoen — twee stappen in één toets is te veel.
        e.stopPropagation();
        sluit();
      }
    });

    /* Klikken ín het paneel: chips, wisknoppen, de sluitknop, en het bewaren
       van de zoekterm zodra er werkelijk ergens heen genavigeerd wordt. */
    paneel.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-zoek-term]');
      if (chip) {
        veld.value = chip.dataset.zoekTerm;
        veld.focus();
        zoek(chip.dataset.zoekTerm);
        return;
      }
      var wisTerm = e.target.closest('[data-zoek-wis-term]');
      if (wisTerm) {
        wisRecent(wisTerm.dataset.zoekWisTerm);
        toonLeeg();
        return;
      }
      if (e.target.closest('[data-zoek-wis-alles]')) {
        wisRecent();
        toonLeeg();
        return;
      }
      if (e.target.closest('[data-zoek-sluit]')) {
        sluit();
        return;
      }
      var optie = e.target.closest('a[role="option"]');
      if (optie) bewaarRecent(veld.value);
    });

    /* Enter zonder een gekozen suggestie. Twee gevallen die het formulier
       zelf niet kan weten: een merk- of lijnnaam hoort naar die pagina te
       gaan, en een verbeterde term hoort de zoekopdracht te zijn. */
    if (box.tagName === 'FORM') {
      box.addEventListener('submit', function (e) {
        var getypt = (veld.value || '').trim();
        if (!getypt) return;
        bewaarRecent(getypt);

        var doel = window.ncZoekDoel ? window.ncZoekDoel(correctie || getypt) : null;
        if (doel && doel.url) {
          e.preventDefault();
          window.location.href = doel.url;
          return;
        }

        if (correctie && correctie !== getypt) {
          e.preventDefault();
          window.location.href = (box.getAttribute('action') || '/search') +
            '?q=' + encodeURIComponent(correctie);
        }
      });
    }

    /* Klikken op een suggestie mag niet wegvallen doordat het veld eerst zijn
       focus verliest — vandaar focusout met een blik op waar de focus heen
       gaat, in plaats van een blur met een timer. */
    box.addEventListener('focusout', function (e) {
      if (!box.contains(e.relatedTarget)) sluit();
    });

    document.addEventListener('click', function (e) {
      if (box.contains(e.target)) return;
      // Een klik op een wisknop bouwt het paneel opnieuw op; tegen de tijd dat
      // dit handvat draait is dat knopje uit de DOM en lijkt de klik daardoor
      // van buiten te komen. Een echt element buiten het vak is nog gewoon
      // verbonden — een losgeraakt element was dus van binnen.
      if (!e.target.isConnected) return;
      // De tik die de zoeklade opent is óók een klik buiten dit vak, en dit
      // handvat draait ná de overlaybeheerder — de lade staat dan al open.
      // Die tik mag het paneel niet sluiten, en hij is meteen hét moment om
      // de beginstand te tonen: dat maakt het openen onafhankelijk van het
      // focus-event, dat niet in elke omgeving betrouwbaar vuurt.
      var opener = e.target.closest('[data-overlay-open]');
      if (opener) {
        var overlay = box.closest('[data-overlay]');
        if (overlay && overlay.id === opener.getAttribute('data-overlay-open')) {
          var vraag = veld.value.trim();
          if (vraag.length < MINIMUM) {
            toonLeeg();
          } else {
            zoek(vraag);
          }
          return;
        }
      }
      sluit();
    });
  }

  document.querySelectorAll('[data-zoekbox]').forEach(maakBox);
})();
